<script setup lang="ts">
export interface IconEventNotFoundProps {
  isDarkTheme?: boolean;
}
const props = withDefaults(defineProps<IconEventNotFoundProps>(), { isDarkTheme: true });
</script>

<template>
  <div class="flex gap-2 mb-10">
    <template v-if="props.isDarkTheme">
      <svg width="94" height="88" viewBox="0 0 94 88" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <rect fill="#1C2535" width="94" height="88" rx="1.767" />
          <rect fill="#2C374B" x="8" y="8" width="78" height="36" rx="2" />
          <g transform="translate(8 52)" fill="#2C374B">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="58" height="6" rx=".883" />
          </g>
          <g transform="translate(8 68)" fill="#2C374B">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="45" height="6" rx=".883" />
          </g>
        </g>
      </svg>
      <svg width="94" height="88" viewBox="0 0 94 88" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <rect fill="#1C2535" width="94" height="88" rx="1.767" />
          <rect fill="#2C374B" x="8" y="8" width="78" height="36" rx="2" />
          <g transform="translate(8 52)" fill="#2C374B">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="58" height="6" rx=".883" />
          </g>
          <g transform="translate(8 68)" fill="#2C374B">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="45" height="6" rx=".883" />
          </g>
        </g>
      </svg>
      <svg width="94" height="88" viewBox="0 0 94 88" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <rect fill="#1C2535" width="94" height="88" rx="1.767" />
          <rect fill="#2C374B" x="8" y="8" width="78" height="36" rx="2" />
          <g transform="translate(8 52)" fill="#2C374B">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="58" height="6" rx=".883" />
          </g>
          <g transform="translate(8 68)" fill="#2C374B">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="45" height="6" rx=".883" />
          </g>
        </g>
      </svg>
    </template>
    <template v-else>
      <svg width="94" height="88" viewBox="0 0 94 88" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <rect fill="#EEE" width="94" height="88" rx="1.767" />
          <rect fill="#E4E3E3" x="8" y="8" width="78" height="36" rx="2" />
          <g transform="translate(8 52)" fill="#E4E3E3">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="58" height="6" rx=".883" />
          </g>
          <g transform="translate(8 68)" fill="#E4E3E3">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="45" height="6" rx=".883" />
          </g>
        </g>
      </svg>
      <svg width="94" height="88" viewBox="0 0 94 88" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <rect fill="#EEE" width="94" height="88" rx="1.767" />
          <rect fill="#E4E3E3" x="8" y="8" width="78" height="36" rx="2" />
          <g transform="translate(8 52)" fill="#E4E3E3">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="58" height="6" rx=".883" />
          </g>
          <g transform="translate(8 68)" fill="#E4E3E3">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="45" height="6" rx=".883" />
          </g>
        </g>
      </svg>
      <svg width="94" height="88" viewBox="0 0 94 88" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <rect fill="#EEE" width="94" height="88" rx="1.767" />
          <rect fill="#E4E3E3" x="8" y="8" width="78" height="36" rx="2" />
          <g transform="translate(8 52)" fill="#E4E3E3">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="58" height="6" rx=".883" />
          </g>
          <g transform="translate(8 68)" fill="#E4E3E3">
            <circle cx="6" cy="6" r="6" />
            <rect x="16" y="3" width="45" height="6" rx=".883" />
          </g>
        </g>
      </svg>
    </template>
  </div>
</template>
